import app from 'flarum/forum/app';
import Submission from '../models/Submission';

export default class SubmissionListState {
    params: any
    submissions: Submission[] = []
    moreResults: boolean = false
    loading: boolean = true

    constructor(params: any = {}) {
        this.params = params;
    }

    requestParams() {
        const params: any = {filter: {}};

        params.sort = this.sortMap()[this.params.sort];

        if (this.params.q) {
            params.filter.q = this.params.q;
        }

        return params;
    }

    sortMap() {
        const map: any = {};

        map.latest = '-createdAt';
        map.oldest = 'createdAt';

        return map;
    }

    clear() {
        this.submissions = [];
        m.redraw();
    }

    refresh({deferClear = false} = {}) {
        this.loading = true;

        if (!deferClear) {
            this.clear();
        }

        return this.loadResults().then(
            results => {
                this.submissions = [];
                this.parseResults(results);
            },
            () => {
                this.loading = false;
                m.redraw();
            }
        );
    }

    loadResults(offset: number = 0) {
        const preloadedSubmissions = app.preloadedApiDocument();

        if (preloadedSubmissions) {
            return Promise.resolve(preloadedSubmissions);
        }

        const params = this.requestParams();
        params.page = {offset};

        return app.store.find('formulaire/submissions', params);
    }

    loadMore() {
        this.loading = true;

        this.loadResults(this.submissions.length)
            .then(this.parseResults.bind(this));
    }

    parseResults(results: any) {
        this.submissions.push(...results);

        this.loading = false;
        this.moreResults = !!results.payload.links && !!results.payload.links.next;

        m.redraw();

        return results;
    }
}
